<div class="d-flex align-items-center gap-3 flex-shrink-0">
    <div ngbDropdown placement="bottom-end" autoClose="outside" class="d-none d-lg-block">
        <button type="button" class="btn btn-light d-flex align-items-center gap-2" ngbDropdownToggle>
            <i class="fa-solid fa-language"></i>
            <span>{{ currentLanguageLabel() }}</span>
        </button>

        <div ngbDropdownMenu>
            @for (language of supportedLanguages(); track language.code) {
            <button ngbDropdownItem type="button" class="d-flex align-items-center justify-content-between gap-2"
                [class.active]="isCurrentLang(language.code)" (click)="changeLang(language.code)">
                <span>{{ language.label }}</span>
                @if (isCurrentLang(language.code)) {
                <i class="fa-solid fa-check" aria-hidden="true"></i>
                }
            </button>
            }
        </div>
    </div>

    <button type="button" (click)="toggleTheme()" class="btn btn-light d-none d-lg-block">
        <i class="fa-solid me-1" [class.fa-sun]="theme()!=='light'" [class.fa-moon]="theme()==='light'"></i>
        <span>{{ 'components.organisms.topbar.themes.'+(theme()==='light' ? 'dark' : 'light') | translate }}</span>
    </button>

    <div ngbDropdown placement="bottom-end" autoClose="outside" class="d-lg-none">
        <button type="button" class="btn btn-light d-flex align-items-center gap-2 border" ngbDropdownToggle>
            <i class="fa-solid fa-bars fa-lg p-2"></i>
        </button>

        <div ngbDropdownMenu>
            <button ngbDropdownItem type="button" class="d-flex align-items-center justify-content-between gap-2"
                (click)="$event.stopPropagation(); toggleLanguageMenu()">
                <span class="d-flex align-items-center gap-2">
                    <i class="fa-solid fa-language"></i>
                    <span>{{ currentLanguageLabel() }}</span>
                </span>
                <i class="fa-solid small" [class.fa-chevron-down]="!languageMenuOpen()"
                    [class.fa-chevron-up]="languageMenuOpen()" aria-hidden="true">
                </i>
            </button>

            @if (languageMenuOpen()) {
            <div class="language-submenu">
                @for (language of supportedLanguages(); track language.code) {
                <button type="button"
                    class="dropdown-item language-submenu-item d-flex align-items-center justify-content-between gap-2"
                    [class.active]="isCurrentLang(language.code)"
                    (click)="$event.stopPropagation(); changeLang(language.code)">
                    <span>{{ language.label }}</span>
                    @if (isCurrentLang(language.code)) {
                    <i class="fa-solid fa-check" aria-hidden="true"></i>
                    }
                </button>
                }
            </div>
            }

            <button ngbDropdownItem type="button" (click)="toggleTheme()">
                <i class="fa-solid me-1" [class.fa-sun]="theme()!=='light'" [class.fa-moon]="theme()==='light'"></i>
                <span>{{ 'components.organisms.topbar.themes.'+(theme()==='light' ? 'dark' : 'light') | translate
                    }}</span>
            </button>
        </div>
    </div>
</div>